import { render, staticRenderFns } from "./mySampleInfor.vue?vue&type=template&id=f15c3ca4&scoped=true&"
import script from "./mySampleInfor.vue?vue&type=script&lang=js&"
export * from "./mySampleInfor.vue?vue&type=script&lang=js&"
import style0 from "./mySampleInfor.vue?vue&type=style&index=0&id=f15c3ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15c3ca4",
  null
  
)

export default component.exports